import { prefixObjectValues as pre } from '../../utils';
const prefix = 'education-detail-table';
const table = pre(
  {
    addBtn: 'add-btn',
    deleteBtn: 'delete-btn-',
    row: 'row-',
    label: 'label-',
    text: 'text-',
    openCreateModal: 'open-create-modal',
  },
  prefix
);

export default table;
